<template>
  <b-row class="app-section" :class="{ 'full-page': isFiltered }">
    <b-col class="h-100 p-3" style="overflow-y: scroll;">
      <!-- Below is the side filter, disable for now.
        <b-col class="h-100 side-filter" cols="2">
          <side-filter :instSelectedCount="0"></side-filter>
        </b-col> -->
      <b-card
        align="left"
        v-for="inst in instruments"
        :key="`${inst.reference_designator}--realtime`"
        class="realtime-inst-card"
        body-class="realtime-card-body"
      >
        <b-card-header
          role="tab"
          header-class="realtime-header"
          v-b-toggle="`${inst.reference_designator}--accordion`"
        >
          <b-row>
            <b-col cols="10">
              <h5 style="font-weight: bold; font-size: 1rem">
                {{ inst.formal_name }}
                <i
                  class="fas fa-info-circle"
                  title="Instrument Details"
                  :id="`${inst.reference_designator}--detail-info`"
                ></i>
                <span
                  :title="inst.harvest_flag === true
                    ? 'Cloud data available.'
                    : 'Currently not in Interactive Oceans systems.'"
                  :class="inst.harvest_flag === false
                    ? 'text-muted'
                    : ''"
                >
                  <i class="fas fa-cloud"></i>
                </span>
                <span
                  title="Not streaming from Interactive Oceans system."
                  v-if="!isActiveStreams(realtimeSources[inst.reference_designator])"
                  class="red-circle">
                  <i class="fas fa-minus-circle"></i>
                </span>
                <span
                  title="Streaming from Interactive Oceans system."
                  v-if="isActiveStreams(realtimeSources[inst.reference_designator])"
                  class="green-circle">
                  <i class="fas fa-rss"></i>
                </span>
                <br />
                <small>{{ siteName(inst.site_rd) }}</small>
                <br />
                <small>{{ infraName(inst.infra_rd) }}</small>
              </h5>
              <b-popover
                :target="`${inst.reference_designator}--detail-info`"
                :ref="`${inst.reference_designator}--detail-info-popover`"
                placement="right"
                triggers="hover"
                boundary="viewport"
                no-fade
              >
                <div style="font-size: 0.8rem">
                  <span title="Reference Designator">
                    <i class="fas fa-hashtag"></i>
                  </span>
                  {{ inst.reference_designator }}
                  <br />
                  <span title="Site Location">
                    <i class="fas fa-map-marked-alt"></i>
                  </span>
                  {{ siteName(inst.site_rd) }}
                  <br />
                  <span title="Infrastructure Location">
                    <i class="fas fa-map-marker-alt"></i>
                  </span>
                  {{ infraName(inst.infra_rd) }}
                  <br />
                  <span title="Description">
                    <i class="fas fa-align-right"></i>
                  </span>
                  {{ inst.description }}
                  <br />
                  <span title="Model">
                    <i class="fas fa-qrcode"></i>
                  </span>
                  {{ inst.model ? inst.model : "N/A" }}
                  <br />
                  <span title="Manufacturer">
                    <i class="fas fa-industry"></i>
                  </span>
                  {{ inst.manufacturer ? inst.manufacturer : "N/A" }}
                  <br />
                  <span title="Owner">
                    <i class="fas fa-user"></i>
                  </span>
                  {{ inst.owner ? inst.owner : "N/A" }}
                </div>
              </b-popover>
            </b-col>
            <b-col cols="2" class="text-right" style="padding: 1rem 2rem">
              <i class="fas fa-chevron-down"></i>
            </b-col>
          </b-row>
        </b-card-header>
        <b-collapse
          :id="`${inst.reference_designator}--accordion`"
          v-model="inst.visible"
          accordion="realtime-accordion"
          role="tabpanel"
        >
          <b-card-body body-class="realtime-body">
            <b-row>
              <b-col cols="12">
                <rt-plot-tabs
                  :streams="realtimeSources[inst.reference_designator]"
                  :visible="inst.visible"
                  v-if="!serverDown"
                ></rt-plot-tabs>
                <p v-if="serverDown && inst.harvest_flag">
                  Our realtime server is currently down. Please check back
                  later.
                </p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import store from '@/store';
import RTPlotTabsVue from './RTPlotTabs';
import { APIREALTIME, APIREALTIMEBASE } from '../../utils/constants';

export default {
  components: {
    'rt-plot-tabs': RTPlotTabsVue,
  },
  data() {
    return {
      realtimeSources: {},
      infraList: [],
      currentSockets: [],
      selectedArea: '',
      instruments: [],
      serverDown: false,
      appReady: false,
    };
  },
  computed: {
    ...mapState({
      instrumentsCatalog: (state) => state.instrumentsCatalog,
      infrastructures: (state) => state.infrastructures,
      sites: (state) => state.sites.features,
    }),
    routeId() {
      return this.$route.params.inst_group;
    },
    isFiltered() {
      if (this.routeId === 'all') {
        return false;
      }
      return true;
    },
    streamedSources() {
      // Filter instrumentsCatalog to grab only streamed stream.
      return _.filter(this.instrumentsCatalog, ['stream_method', 'streamed']);
    },
    cleanedSources() {
      return _.map(this.streamedSources, (val) => ({
        data_table: val.data_table,
        inst_group: val.instrument.instrument_url.split('/')[2],
        instrument: val.instrument,
        active: false,
      }));
    },
    defaultSources() {
      // let filteredSources;
      if (this.routeId === 'all') {
        return this.cleanedSources;
      }
      return _.filter(this.cleanedSources, ['inst_group', this.routeId]);
    },
    singleInstrument() {
      const filteredSources = _.filter(this.cleanedSources, [
        'inst_group',
        this.routeId,
      ]);
      return filteredSources[0];
    },
  },
  created() {
    if (this.isFiltered === true) {
      const navBar = document.getElementById('navbar-container');
      navBar.style.display = 'none';
      navBar.style.height = '0';
    }
    this.fetchSources();
  },
  methods: {
    isActiveStreams(streams) {
      const activeStremas = _.filter(streams, ['active', true]);
      if (activeStremas.length > 0) {
        return true;
      }
      return false;
    },
    // Gets the formal site name from the sites endpoint
    siteName(siteRd) {
      const siteName = _.find(this.sites, [
        'properties.reference_designator',
        siteRd,
      ]);
      if (siteName) {
        return siteName.properties.site_name;
      }
      return '';
    },
    // Gets the formal infra name from the infrastructure endpoint
    infraName(infraRd) {
      const infraName = _.find(this.infrastructures, [
        'reference_designator',
        infraRd,
      ]);
      if (infraName) {
        return infraName.infraName;
      }
      return '';
    },
    getInstruments(data) {
      const sources = _.filter(
        _.map(data, (source) => {
          const inst = _.find(this.instrumentsCatalog, ['data_table', source.data_table]);
          if (inst) {
            return { ...inst, active: source.active };
          }
          return null;
        }),
        null,
      );
      this.realtimeSources = _.groupBy(sources, 'instrument_rd');
      const allInstruments = store.state.instruments;
      const filteredInstruments = _.filter(
        allInstruments,
        (o) => _.has(this.realtimeSources, o.reference_designator),
      );
      this.instruments = _.map(filteredInstruments, (inst) => ({ ...inst, visible: false }));
      this.appReady = true;
    },
    fetchSources() {
      axios
        .get(`${APIREALTIMEBASE}/${APIREALTIME}/sources`)
        .then((response) => {
          this.serverDown = false;
          const { data } = response;
          const filteredData = _.map(this.defaultSources, (o) => {
            if (_.includes(data, o.data_table)) {
              return {
                ...o,
                active: true,
              };
            }
            return o;
          });
          this.getInstruments(filteredData);
          // this.getInstruments(_.map(this.defaultSources, 'data_table'));
        })
        .catch((err) => {
          this.serverDown = true;
          this.getInstruments(this.defaultSources, 'data_table');
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
  },
};
</script>

<style>
.realtime-inst-card {
  margin: 1rem;
}

.realtime-header {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: 0 !important;
  padding: 1rem !important;
}

.realtime-body {
  padding: 1rem !important;
}

.full-page {
  height: 100% !important;
  background-color: #EDEDED;
}

.realtime-card-body {
  padding: 0 !important;
}

.red-circle {
  color: rgb(182, 52, 52);
}
.green-circle {
  color: rgb(72, 182, 52);
}
</style>
